import { Helmet } from 'react-helmet-async';
import React from 'react';
import NotificationContainer from '../../../../containers/notification/NotificationsContainer.jsx';
import PermissionsContainer from '../../../../containers/organizations/PermissionsContainer.jsx';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

const Permissions = ({ userId, slug }) => (
  <>
    <Helmet>
      <title>Permissions | ChangeSync</title>
    </Helmet>
    <NotificationContainer />
    <PermissionsContainer slug={slug} userId={userId} />
  </>
);
Permissions.getInitialProps = ({ query }) => ({
  slug: query.slug,
  userId: Number(query.userId),
});

export default requireAuth(withRouterParams(Permissions));
